import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useWatch } from 'react-hook-form';

const dataProviderName = 'commercials/areaSource';
const model = 'commercials/areaSource';
const modelExposedName = 'areaSource';
const wizardAction = 'manageBudget';

const Manage = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [costGroupSelectorParams, setCostGroupSelectorParams] = useState({ _related_area_id: null, year: new Date().getFullYear() });
    const [detailConfig, setDetailConfig] = useState();
    const modelName = existingModules.modelName

    // DATA PROVIDER
    const { items: areas, loadAll: loadAllAreas, success: successAreas } = useDataProvider('commercials/area');
    const { doAction, items: areasources, loadAll: loadAllAreaSources, errorMessage, errors, saving, success } = useDataProvider('commercials/areaSource');

    const areasLoaded = useRef(false);
    const [editing, setEditing] = useState(false)
    const [dataComplete, setDataComplete] = useState(false)
    const [budgetValues, setBudgetValues] = useState([])
    const [centralTotalBudget, setCentralTotalBudget] = useState(0)
    const [localTotalBudget, setLocalTotalBudget] = useState(0)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    useEffect(() => {
        loadAllAreas();
    }, [])

    useEffect(() => {
        if (!areas || areas.length == 0 || areasLoaded.current) return;

        prepareDetailConfig(areas, areasources);
        areasLoaded.current = true;

    }, [areas])

    const prepareDetailConfig = (areas, areasources) => {

        const detailConfig = {
            "tabs": [
                {
                    "name": "management",
                    "fieldsets": [
                        {
                            "name": "filters",
                            "fields": {
                                "_related_area_id": {
                                    "type": "select",
                                    "label": "area",
                                    "className": "col-6",
                                    "required": true,
                                    "options": getSelectableAreas(areas)
                                },
                                "year": {
                                    "type": "select",
                                    "label": "year",
                                    "className": "col-6",
                                    "required": true,
                                    "options": [
                                        { label: 2019, value: 2019 },
                                        { label: 2020, value: 2020 },
                                        { label: 2021, value: 2021 },
                                        { label: 2022, value: 2022 },
                                        { label: 2023, value: 2023 },
                                        { label: 2024, value: 2024 },
                                        { label: 2025, value: 2025 },
                                        { label: 2026, value: 2026 },
                                        { label: 2027, value: 2027 },
                                        { label: 2028, value: 2028 },
                                        { label: 2029, value: 2029 },
                                        { label: 2030, value: 2030 }
                                    ]
                                },
                            }
                        }
                    ]
                }
            ],
            "validation": []
        };

        let fieldsetCosts;
        const allValuesSet = Object.values(costGroupSelectorParams).every(value => value !== null && value !== undefined);
        if (areasources.length > 0) {
            fieldsetCosts = {
                "name": "budget",
                "fields": getBudgetFields(areasources)
            }
        } else if (dataComplete == -1) {
            fieldsetCosts = {
                "name": "budget",
                "fields": {
                    "loading_data": {
                        "type": "sectionmessageblock",
                        "title": "missingareasourceyear_message_title",
                        "paragraph": "missingareasourceyear_message_paragraph",
                        "icon": "faWarning",
                        "className": "col-12 danger",
                    }
                }
            }
        } else if (allValuesSet) {
            fieldsetCosts = {
                "name": "budget",
                "fields": {
                    "loading_data": {
                        "type": "sectionmessageblock",
                        "title": "loading_message_title",
                        "paragraph": "loading_message_paragraph",
                        "icon": "faClock",
                        "className": "col-12 warning",
                    }
                }
            }
        } else {
            fieldsetCosts = {
                "name": "budget",
                "fields": {
                    "complete_data": {
                        "type": "sectionmessageblock",
                        "title": "complete_data_budget_message_title",
                        "paragraph": "complete_data_budget_message_paragraph",
                        "icon": "faPen",
                        "className": "col-12 info",
                    }
                }
            }
        }
        detailConfig.tabs[0].fieldsets.push(fieldsetCosts);
        prepareBudgetValues();
        setDetailConfig(detailConfig);
    }

    const getSelectableAreas = (areas) => {
        return areas
            .filter((area) => area.name)
            .map((area) => ({ "label": area.name, "value": area._id }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }

    const getBudgetFields = (areasources) => {
        const budgetFields = areasources
            .sort((a, b) => {
                const nameA = String(a._related_source_name || a.name || '');
                const nameB = String(b._related_source_name || b.name || '');
                return nameA.localeCompare(nameB);
            })
            .reduce((fields, areasource) => {
                // fields.Centrale = fields.Centrale || {};
                // fields.Locale = fields.Locale || {};

                if (Object.keys(fields).length === 0) {
                    fields['HeaderCentrale'] = {
                        "type": "sectiontitle",
                        "icon": "faGlobe",
                        "label": "Centrale",
                        "className": "col-6 mt-0"
                    };
                    fields['HeaderLocale'] = {
                        "type": "sectiontitle",
                        "icon": "faShop",
                        "label": "Locale",
                        "className": "col-6 mt-0"
                    };
                }

                fields["Centrale_" + areasource._original_id] = {
                    "type": "text",
                    "icon": "faGlobe",
                    "label": areasource._related_source_name || areasource.name.split(' | ')[1] || '',
                    "className": "col-2"
                };
                fields["Centrale_budget_" + areasource._original_id] = {
                    "type": "budgetChecker",
                    "areaSource": areasource._id,
                    "area": areasource._related_area_name,
                    "source": areasource._related_source_name,
                    "budgetType": "Centrale",
                    "year": areasource.year,
                    "budget": areasource.budgetCentrale,
                    "budgetEroded": areasource.budgetCentraleEroded,
                    "budgetRemaining": areasource.budgetCentraleRemaining,
                    "className": "col-4"
                };
                fields["Locale_" + areasource._original_id] = {
                    "type": "text",
                    "icon": "faShop",
                    "label": areasource._related_source_name || areasource.name.split(' | ')[1] || '',
                    "className": "col-2"
                };
                fields["Locale_budget_" + areasource._original_id] = {
                    "type": "budgetChecker",
                    "areaSource": areasource._id,
                    "area": areasource._related_area_name,
                    "source": areasource._related_source_name,
                    "budgetType": "Locale",
                    "year": areasource.year,
                    "budget": areasource.budgetLocale,
                    "budgetEroded": areasource.budgetLocaleEroded,
                    "budgetRemaining": areasource.budgetLocaleRemaining,
                    "className": "col-4"
                };
                return fields;
            }, {});

        console.info('..........getBudgetFields', budgetFields);
        return budgetFields;
    }

    const prepareBudgetValues = () => {
        // creo le posizioni di costo in base alle areasources esistenti
        const budgetValues = areasources.reduce((acc, areasource) => {
            acc['Centrale_' + areasource._id] = areasource.budgetCentrale ?? 0; // valore di default
            acc['Locale_' + areasource._id] = areasource.budgetLocale ?? 0; // valore di default
            return acc;
        }, {});

        let centralTotalBudget = 0;
        let localTotalBudget = 0;
        // popolo i costi provenienti dal server
        areasources.forEach(areasource => {
            centralTotalBudget += areasource['budgetCentrale'] ?? 0;
            localTotalBudget += areasource['budgetLocale'] ?? 0;
        });

        setCentralTotalBudget(centralTotalBudget);
        setLocalTotalBudget(localTotalBudget);

        setBudgetValues(budgetValues);
    }

    const onChangeFieldValueAction = (field, value, setFormValues, stepActive, setValue, getValues) => {
        //console.info('++++ onChangeFieldValueAction: Valuto cosa fare', field, value, costGroupSelectorParams)
        if (costGroupSelectorParams.hasOwnProperty(field)) {
            const newparams = { ...costGroupSelectorParams };
            newparams[field] = value;
            setCostGroupSelectorParams(newparams)
        }
        //setSetValue(setValue);
    }

    const getFiltersToLoadAreaSources = () => {
        // preparo i filtri per la query sulla collection areasource
        // a) tutti i filtri tranne le budget type e month
        const filterItems = Object.entries(costGroupSelectorParams).map(([field, value]) => {
            if (['budgetType', 'month'].includes(field)) return null
            return {
                field: field,
                operator: 'equals',
                value: value
            }
        }).filter((item) => item !== null)

        return filterItems;
    }

    useEffect(() => {
        const allValuesSet = Object.values(costGroupSelectorParams).every(value => value !== null && value !== undefined);

        if (allValuesSet) {
            setDataComplete(false);
            loadAllAreaSources({
                items: getFiltersToLoadAreaSources()
            }).then((res) => {
                if ((res?.items?.data ?? []).length > 0) {
                    setDataComplete(true)
                } else {
                    setDataComplete(-1)
                }
            })
        }
    }, [costGroupSelectorParams])

    useEffect(() => {
        prepareDetailConfig(areas, areasources)
    }, [dataComplete])

    return (
        <>
            <DetailComponent
                values={{
                    ...costGroupSelectorParams,
                    ...budgetValues
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                loading={!areasLoaded.current}
                errors={errors}
                errorMessage={errorMessage}
                title={t('Verifica andamento budget')}
                canSave={dataComplete && userCapabilities && userCapabilities[dataProviderName + '.edit']}
                header={
                    <InfoHeader
                        view="budget"
                        title={t('Verifica andamento budget')}
                        subtitle={t('Select an Area to manage the related yearly budget')}
                        central={centralTotalBudget}
                        local={localTotalBudget}
                    />
                }
                {...params}
                onChangeFieldValueAction={onChangeFieldValueAction}
            />
        </>
    )
}

export default Manage